import {
  GetInstrumentQuery,
  Instrument,
  ListQuestionsQuery,
  ModelQuestionConnection,
  Question,
  UpdateInstrumentInput,
  UpdateInstrumentMutation
} from "../../API";
import { genericQuery, listQueryAutoPaginated } from "../api/apiUtils";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";

export const updateInstrument = async (input: UpdateInstrumentInput) => {
  const predicate = { input: input };
  return await genericQuery<UpdateInstrumentMutation, Instrument>(
    mutations.updateInstrument,
    "updateInstrument",
    predicate
  );
};

export const fetchInstrument = async (id: string) => {
  const predicate = { id: id };
  const instrument = await genericQuery<GetInstrumentQuery, Instrument>(
    queries.getInstrument,
    "getInstrument",
    predicate
  );
  // Need to grab the questions object because the depth setting can't grab everything from the assessment level.
  const questionsPredicate = {
    filter: { instrumentId: { eq: instrument?.id } }
  };
  const questions = await listQueryAutoPaginated<
    ListQuestionsQuery,
    Question,
    ModelQuestionConnection
  >(queries.listQuestions, "listQuestions", "items", questionsPredicate);
  // Create the expected connection type
  const questionsConnection: ModelQuestionConnection = {
    __typename: "ModelQuestionConnection",
    items: questions || []
  };
  if (instrument && questions) {
    instrument.questions = questionsConnection;
  }
  return instrument;
};
